import { LOGIN_FAILED, LOGIN_FETCHING, LOGIN_SUCCESS, LOGOUT, server } from '../../constants'
import backendEndpoint from '../../api/etrBackend'
import { requestLoginModel, responseLoginModel } from '../../models/login'
import authService from '../../Services/auth'
import loginMock from '../../mockData/db.json'
export const setLoginFetchingToState = () => ({
  type: LOGIN_FETCHING
})

export const setLoginSuccessToState = (payload: any) => ({
  type: LOGIN_SUCCESS,
  payload
})

export const setLoginFailedToState = (payload: any) => ({
  type: LOGIN_FAILED,
  payload
})

export const setLoginLogoutToState = () => ({
  type: LOGOUT
})

export const handleReLogin = (reLoginData: responseLoginModel | undefined) => {
  return async (dispatch: any) => {
    try {
      if (reLoginData) {
        dispatch(setLoginSuccessToState(reLoginData))
      } else {
        //dispatch(setLoginFailedToState())
      }
    } catch (error) {
      //dispatch(setLoginFailedToState())
    }
  }
}

export const handleLogin = (reqLogin: requestLoginModel, history: any) => {
  return async (dispatch: any) => {
    try {
      let req: any = reqLogin
      if (window._env_.NODE_ENV === 'local') {
        req = loginMock.login
      }
      dispatch(setLoginFetchingToState())
      const result = await backendEndpoint.post(
        reqLogin.isFWDStaff ? server.FWD_STAFF_LOGIN_URL : server.LOGIN_URL,
        req
      )
      if (result.data.authenticated) {
        authService.createSession(result.data)
        dispatch(setLoginSuccessToState(result.data))
        history('/')
      } else {
        dispatch(setLoginFailedToState(result.data))
      }
    } catch (error) {
      dispatch(setLoginFailedToState(null))
    }
  }
}

export const handleLogout = (isBranchStaff: boolean, history: any) => {
  return async (dispatch: any) => {
    const user = authService.getUserName()
    if (!isBranchStaff) {
      const result = await backendEndpoint.post(`${server.LOGOUT_URL}/${user}`)
    }
    authService.logout()
    dispatch(setLoginLogoutToState())
    history('/login')
  }
}

//   export const handleReLogin = () => {
//     return (dispatch: any) => {
//       const token = localStorage.getItem(server.TOKEN_KEY);
//       if (token) {
//         dispatch(setLoginSuccessToState({ token }));
//       }
//     };
//   };
